import React from 'react';
import { Switch, Route } from 'react-router-dom';
import MainPage from './components/MainPage';
import Unknown from './components/UnknownPage';

export function Router() {
  return (
    <Switch>
      <Route exact path="/" component={MainPage} />
      <Route component={Unknown} />
    </Switch>
  );
}
